(function(){
  if(window.__pkCore) return; window.__pkCore = true;

  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function goTo(el){
    try{ el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start', inline: 'nearest' }); }
    catch(e){ el.scrollIntoView(true); }
  }
  document.addEventListener('click', function(e){
    if(e.defaultPrevented || e.button) return;
    var a = e.target && e.target.closest ? e.target.closest('a[href*="#"]') : null;
    if(!a) return;
    var href = a.getAttribute('href') || '';
    var i = href.indexOf('#'); if(i < 0) return;
    var pathPart = href.slice(0, i), id = href.slice(i + 1);
    if(!id || (pathPart && pathPart !== location.pathname)) return;
    var el = document.getElementById(id); if(!el) return;
    e.preventDefault();
    goTo(el);
    try{ history.replaceState(null, '', '#' + id); }catch(err){}
  });
  if(location.hash && location.hash.length > 1){
    var target = document.getElementById(location.hash.slice(1));
    if(target){ window.addEventListener('load', function(){ setTimeout(function(){ goTo(target); }, 120); }); }
  }

  function sbarGuard(){
    var atc = document.getElementById('pkAtc'), bar = document.getElementById('pkSbar');
    if(!atc || !bar) return;
    var scroller = document.querySelector('.page-wrapper') || window;
    var ticking = false;
    function check(){
      ticking = false;
      if(bar.classList.contains('is-on') && atc.getBoundingClientRect().top > 0){ bar.classList.remove('is-on'); }
    }
    function onScroll(){ if(!ticking){ ticking = true; requestAnimationFrame(check); } }
    scroller.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('scroll', onScroll, { passive: true });
    new MutationObserver(function(){ if(bar.classList.contains('is-on')) onScroll(); }).observe(bar, { attributes: true, attributeFilter: ['class'] });
    check();
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sbarGuard); else sbarGuard();

  document.addEventListener('pointerup', function(e){
    if(e.button && e.button !== 0) return;
    var t = e.target && e.target.closest ? e.target.closest('.pk-sw__b, .pk-pk, .pk-xr__tab, .pk-fl__c, .pk-wiz, a, button') : null;
    if(t) return;
    var els = document.querySelectorAll('.pk-sw__b, .pk-pk');
    for(var i=0;i<els.length;i++){
      var r = els[i].getBoundingClientRect();
      if(e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom){ els[i].click(); return; }
    }
  }, true);

  window.__pkLastInput = 0;
  ['pointerdown','keydown','touchstart'].forEach(function(ev){ document.addEventListener(ev, function(){ window.__pkLastInput = Date.now(); }, { capture:true, passive:true }); });
})();

/* Naviro v5: header cart icon opens the Naviro drawer (with the bump), not the theme's default drawer; keeps the bubble count in sync.
   Registered on window in capture phase so it runs before the theme's own delegated handlers. */
(function(){
  if(window.__pkHdr) return; window.__pkHdr = true;
  function closeNative(){ try{ var d = document.querySelector('#cart-drawer dialog'); if(d && d.open) d.close(); }catch(err){} }
  window.addEventListener('click', function(e){
    var t = e.target && e.target.closest ? e.target.closest('[data-testid="cart-drawer-trigger"], a.action__cart, [aria-controls="cart-drawer"]') : null;
    if(!t || !window.pkCart) return;
    e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation();
    closeNative();
    window.pkCart.open();
    setTimeout(closeNative, 50); setTimeout(closeNative, 300);
  }, true);
  function sync(){
    fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){
      var q = c.item_count || 0;
      document.querySelectorAll('.cart-bubble__text-count').forEach(function(el){ el.textContent = q > 0 ? String(q) : ''; el.classList.toggle('hidden', q === 0); });
      document.querySelectorAll('.cart-bubble').forEach(function(el){ el.classList.toggle('visually-hidden', q === 0); });
      document.querySelectorAll('.header-actions__cart-icon').forEach(function(el){ el.classList.toggle('header-actions__cart-icon--has-cart', q > 0); });
    }).catch(function(){});
  }
  var _f = window.fetch;
  window.fetch = function(u, o){
    var p = _f.apply(this, arguments);
    try{ var url = (typeof u === 'string') ? u : (u && u.url) || ''; if(/\/cart\/(add|change|update)\.js/.test(url)) p.then(function(){ setTimeout(sync, 150); }); }catch(err){}
    return p;
  };
})();
